import variables from 'themes/variables'

import { VIEWPORT_MODES } from './constants'

const { sizes } = variables.breakpoints

export const MOBILE_MEDIA_QUERY = `(max-width: ${sizes.belowTablet})`
export const TABLET_MEDIA_QUERY = `(max-width: ${sizes.medium})`

export const getViewportMode = () => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return VIEWPORT_MODES.desktop
  }
  if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
    return VIEWPORT_MODES.mobile
  }
  if (window.matchMedia(TABLET_MEDIA_QUERY).matches) {
    return VIEWPORT_MODES.tablet
  }
  return VIEWPORT_MODES.desktop
}

let panelIdCounter = 0

export const createPanelId = () => {
  panelIdCounter += 1
  return `program-nav-dropdown-${panelIdCounter}`
}

let closeActiveDropdown = null

// Only one program nav menu is open at a time: opening one closes the last.
export const claimActiveDropdown = close => {
  if (closeActiveDropdown && closeActiveDropdown !== close) {
    closeActiveDropdown()
  }
  closeActiveDropdown = close
}

export const releaseActiveDropdown = close => {
  if (closeActiveDropdown === close) {
    closeActiveDropdown = null
  }
}

export const isModifiedClick = event =>
  event.button !== 0 ||
  event.metaKey ||
  event.ctrlKey ||
  event.shiftKey ||
  event.altKey
